module.exports = new __parcel__URL__("deployments-preview.78ac1bac.svg").toString();